import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { getSDK } from '../services/sdk-instance';
import { holdsIdentityAtom } from '../stores/auth/atoms';
import { sdkConfiguredAtom } from '../stores/sdk/atoms';
import type { PositionTree as OrgChartResponse, Position as OrgPosition } from '@localagent/sdk';

export function useOrgChart() {
  const isAuthenticated = useAtomValue(holdsIdentityAtom);
  const sdkConfigured = useAtomValue(sdkConfiguredAtom);

  return useQuery<OrgChartResponse, Error>({
    queryKey: ['orgchart', 'tree'],
    queryFn: () => getSDK().orgChart.getOrgChart(),
    enabled: Boolean(isAuthenticated && sdkConfigured),
  });
}

export function usePositions() {
  const isAuthenticated = useAtomValue(holdsIdentityAtom);
  const sdkConfigured = useAtomValue(sdkConfiguredAtom);

  return useQuery<OrgPosition[], Error>({
    queryKey: ['orgchart', 'positions'],
    queryFn: () => getSDK().orgChart.listPositions(),
    enabled: Boolean(isAuthenticated && sdkConfigured),
  });
}
